<app-popover *ngIf="modalStateService.shouldLoad" [flagShowCheckbox]="flagShowCheckbox"></app-popover>